import { gql } from '@apollo/client';

export const GET_SESSION = gql`
    query getSession {
        session @client {
            token
            codeDeliveryDetails
            currentUser {
                email
                id
                name
                username
                userSub
                statementId
            }
            expiration
            isSigningUp
            issuedAt
            sessionIsValid
        }
    }
`;
